export default __webpack_public_path__ + "static/media/icon-invalid-activation.bb7f3fdd.svg";